import $ from 'jquery';

$(function () {
	var w = $(window).width();
	var x = 768;
	if (w <= x) {
		var max_Height, text_Height;
		max_Height = $('.more-read-btn').outerHeight();
		text_Height = $('.more-read-btn').parent().height();
		$('.more-read-btn').parent().css('height', max_Height);
		$('.more-read-btn').on('click', function() {
			$(this).addClass('is-hidden');
			$(this).parent().css('height', text_Height);
		});
	}
});